import Marquee from "react-fast-marquee";

const ITEMS = [
  "100% Custom Original Work",
  "Australian Made",
  "Web Development",
  "E-Commerce",
  "Brand Design",
  "Embroidery",
  "Banners & Signage",
  "Graphic Design",
  "Website Management",
];

export const MarqueeRibbon = () => (
  <div data-testid="marquee-ribbon" className="border-y border-white/10 bg-navy-light/60 py-4 overflow-hidden">
    <Marquee speed={45} gradient={false} pauseOnHover>
      {ITEMS.map((text) => (
        <span key={text} className="flex items-center font-mono text-sm tracking-[0.25em] uppercase text-muted">
          <span className="mx-8">{text}</span>
          <span className="text-signal">//</span>
        </span>
      ))}
    </Marquee>
  </div>
);
